import {TriggerTargeting, NotificationType} from '../../types/reports/messages';

interface SendToNotificationsBuilderArgs {
  projectId: number;
  messageType: NotificationType;
  targetingProps: TriggerTargeting;
  openInNewTab: boolean;
}

export const TARGETED_STORAGE_KEY = `$mp_message_targeting_from_explore`;

export function sendToNotificationsBuilder({
  projectId,
  messageType,
  targetingProps,
  openInNewTab = false,
}: SendToNotificationsBuilderArgs): void {
  // Universal cohort builder expects these keys to be JSON stringified.
  const keysToStringify = new Set([`cohort_selector`, `cohort_behaviors`]);
  const preparedTargetingProps = {};
  for (const [key, value] of Object.entries(targetingProps)) {
    preparedTargetingProps[key] = keysToStringify.has(key) ? JSON.stringify(value) : value;
  }

  localStorage.setItem(TARGETED_STORAGE_KEY, JSON.stringify(preparedTargetingProps));
  const builderUrl = `/report/${projectId}/triggers/messages/#builder/${messageType}/targeted/?step=1`;
  if (openInNewTab) {
    window.open(builderUrl, `_blank`);
  } else {
    window.open(builderUrl, `_self`);
  }
}
